import React, { createContext, useReducer, useState } from 'react';
import pricingReducer from './PricingReducer';

export const initialValue = {
    subscriptions: [],
    currentOrganization: {},
    currentOrganizationStripeData: {},
    currentSubscription: {},
    currentSubscriptionStripeData: {},
    numSeats: 3,
    selectedPlan: {
        price: {}
    },
    selectedSubscriptionParameters: {},
    stripe: {},
    newPriceData: {},
    billingInformation: {},
    taxInfo: {},
    paymentMethods: [],
    selectedPaymentMethodId: "",
    clientSecret: "",
    interval: "annually",
    showDowngradeDialog: false,
    showSeatOverflowDialog: false,
    showProjectOverflowDialog: false,
    showRoleOverflowDialog: false,
    showAddNewCardDialog: false,
    loadingNewPriceData: true,
    numberOfActiveProjects: 0,
    priceChangeSuccessful: false,
    paymentInformationValid: false,
};

export const PricingContext = createContext(initialValue);

function PricingContextProvider({ children, value = {} }) {

    const [state, dispatch] = useReducer(pricingReducer, {
        ...initialValue,
        ...value
    });

    return (
        <PricingContext.Provider value={{
            state, dispatch
        }}>
            { children }
        </PricingContext.Provider>
    )
}

export default PricingContextProvider;